/**
 * Calculate component scores for physical fitness domains
 * 4 Components: Strength, Endurance, Flexibility, Balance
 */

export function calculateComponentScores(physicalTests, testAnalyses) {
  // Map tests to fitness components
  const componentMapping = {
    strength: ['squat', 'lunge', 'pushup'],
    endurance: ['plank', 'highknee'],
    flexibility: ['forwardbend'],
    balance: ['tpose', 'lunge']
  };

  const components = {
    strength: { name: 'Strength', icon: '💪', score: 0, tests: [], color: 'blue' },
    endurance: { name: 'Endurance', icon: '🏃', score: 0, tests: [], color: 'green' },
    flexibility: { name: 'Flexibility', icon: '🤸', score: 0, tests: [], color: 'purple' },
    balance: { name: 'Balance', icon: '⚖️', score: 0, tests: [], color: 'cyan' }
  };

  // Calculate scores for each component
  Object.keys(components).forEach(componentKey => {
    const relevantTestIds = componentMapping[componentKey];
    const relevantTests = testAnalyses.filter(t => relevantTestIds.includes(t.testId));
    
    if (relevantTests.length > 0) {
      const avgScore = relevantTests.reduce((sum, t) => sum + t.score, 0) / relevantTests.length;
      components[componentKey].score = Math.round(avgScore);
      components[componentKey].tests = relevantTests.map(t => t.testName);
    }
  });

  return components;
}

export function getComponentDescription(componentName, score) {
  const descriptions = {
    strength: {
      high: 'Excellent lower and upper body strength! Your power output is impressive.',
      medium: 'Good strength foundation. Continue building power through resistance training.',
      low: 'Focus on strength training to improve power and muscle development.'
    },
    endurance: {
      high: 'Outstanding endurance! You can sustain effort over extended periods.',
      medium: 'Solid endurance base. Increase training duration for further improvements.',
      low: 'Build endurance through consistent cardio and sustained effort exercises.'
    },
    flexibility: {
      high: 'Exceptional flexibility! Your range of motion is excellent.',
      medium: 'Good flexibility. Regular stretching will enhance your mobility.',
      low: 'Improve flexibility through daily stretching and mobility work.'
    },
    balance: {
      high: 'Superior balance and stability! Your body control is excellent.',
      medium: 'Good balance. Practice single-leg exercises for improvement.',
      low: 'Work on balance through stability exercises and core strengthening.'
    }
  };

  const level = score >= 75 ? 'high' : score >= 55 ? 'medium' : 'low';
  return descriptions[componentName.toLowerCase()]?.[level] || 'Continue practicing to improve.';
}
